var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as UnlinkedApplicationForm from "../../../components/UnlinkedApplicationForm";
import { PivotReason, setBundlePivotReason, } from "../../../features/applicant/applicantSlice";
import AppBody from "../../../components/AppBody";
import { Button } from "@savvyinsure/react-ui";
import Header from "../../../components/Header";
import { PHASE } from "../../../routeConfig";
import { completedPage } from "../../../lib/Avo";
import { saveApplicableDiscounts } from "../../../features/unlinked-application/unlinkedApplicationSlice";
import useAppDispatch from "../../../hooks/useAppDispatch";
import useAppSelector from "../../../hooks/useAppSelector";
import useMemoryHistory from "../../../hooks/useMemoryHistory";
export default function UnlinkedApplicationHomeBundleAutoRoute() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var dispatch = useAppDispatch();
    var push = useMemoryHistory().push;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, { showDropShadow: true }),
        React.createElement(AppBody, null,
            React.createElement(UnlinkedApplicationForm.ScrollingContainer, { className: "pt-4" },
                React.createElement(UnlinkedApplicationForm.Header, null, "Do you own any vehicles?"),
                React.createElement("div", { className: "mt-4 space-y-4" },
                    React.createElement(Button, { onClick: function (ev) {
                            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                            dispatch(setBundlePivotReason(PivotReason.BundleAutoFromHome));
                            dispatch(saveApplicableDiscounts({ isHomeowner: true }));
                            push(PHASE.SELECT_AUTO_ISSUER);
                        } }, "Yes"),
                    React.createElement(Button, { variant: "outlined", onClick: function (ev) {
                            completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                            push(PHASE.UNLINKED_APPLICATION_HOMEOWNERS_MILITARY);
                        } }, "No"))))));
}
